module.exports = __webpack_public_path__ + "img/lid_03.dc8c8ee5.png";